/**
 * Shared user-facing labels for build sub-phase identifiers.
 *
 * The IDs come from the build SKILL's progress wire. Surfaces that need
 * detail can fall back to the raw ID; summary surfaces should suppress
 * unknown machine-looking IDs instead of showing internal codes.
 */
export const SUB_PHASE_LABELS: Record<string, string> = {
  'B.1': 'Planning',
  'B.2': 'Plan review prep',
  'B.2.5': 'Plan review checkpoint',
  'B.3': 'Pre-build setup',
  'B.4a': 'Build plan review',
  'B.4b-framework': 'Framework scaffold',
  'B.4b-features': 'Feature implementation',
  'B.4c': 'Post-feature integration',
  'B.5': 'Build review',
  'B.6': 'Final review',
  'B.7': 'Pre-release prep',
  'B.7.5': 'Release handoff',
};

export function knownSubPhaseLabel(subPhaseId: string): string | null {
  return SUB_PHASE_LABELS[subPhaseId] ?? null;
}

export function subPhaseLabel(subPhaseId: string): string {
  return knownSubPhaseLabel(subPhaseId) ?? subPhaseId;
}

export function isMachineSubPhaseId(value: string): boolean {
  return /^B(?:[.-][A-Za-z0-9]+)+$/.test(value);
}
